import { FC, ReactNode } from 'react'
import { BaseModal } from '.'
import { PrimaryButton, SecondaryButton, SecondaryButtonType, Text } from '..'
import { styled } from 'styled-components'

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`

const Buttons = styled.div`
    display: flex;
    gap: 16px;
`

interface ButtonUio {
    icon?: ReactNode
    title: string
    onClick: () => void
}

interface SecondaryButtonUio extends ButtonUio {
    type?: SecondaryButtonType
}

interface Props {
    title: string
    subtitle: string
    secondaryButton?: SecondaryButtonUio
    primaryButton: ButtonUio
    closeButtonOnClick: () => void
}

export const AlertModal: FC<Props> = ({
    title,
    subtitle,
    secondaryButton,
    primaryButton,
    closeButtonOnClick,
}) => {
    return (
        <BaseModal
            title={title}
            closeButtonOnClick={closeButtonOnClick}
            width="small"
        >
            <Content>
                <Text size="medium" $weight="regular">
                    {subtitle}
                </Text>

                <Buttons>
                    {secondaryButton && (
                        <SecondaryButton
                            height="small"
                            width="xSmall"
                            gap="medium"
                            onClick={secondaryButton.onClick}
                            $type={secondaryButton.type ?? 'default'}
                        >
                            {secondaryButton.icon}
                            {secondaryButton.title}
                        </SecondaryButton>
                    )}

                    <PrimaryButton
                        height="small"
                        width="xSmall"
                        gap="medium"
                        onClick={primaryButton.onClick}
                    >
                        {primaryButton.icon}
                        {primaryButton.title}
                    </PrimaryButton>
                </Buttons>
            </Content>
        </BaseModal>
    )
}
